var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4697 8.52991C13.396 8.46125 13.3369 8.37845 13.2959 8.28645C13.2549 8.19445 13.2329 8.09513 13.2311 7.99443C13.2293 7.89373 13.2478 7.7937 13.2856 7.70031C13.3233 7.60692 13.3794 7.52209 13.4506 7.45087C13.5219 7.37965 13.6067 7.32351 13.7001 7.28579C13.7935 7.24807 13.8935 7.22954 13.9942 7.23132C14.0949 7.23309 14.1942 7.25514 14.2862 7.29613C14.3782 7.33712 14.461 7.39622 14.5297 7.46991L18.5297 11.4699C18.6701 11.6105 18.749 11.8012 18.749 11.9999C18.749 12.1987 18.6701 12.3893 18.5297 12.5299L14.5297 16.5299C14.461 16.6036 14.3782 16.6627 14.2862 16.7037C14.1942 16.7447 14.0949 16.7667 13.9942 16.7685C13.8935 16.7703 13.7935 16.7518 13.7001 16.714C13.6067 16.6763 13.5219 16.6202 13.4506 16.5489C13.3794 16.4777 13.3233 16.3929 13.2856 16.2995C13.2478 16.2061 13.2293 16.1061 13.2311 16.0054C13.2329 15.9047 13.2549 15.8054 13.2959 15.7134C13.3369 15.6214 13.396 15.5386 13.4697 15.4699L16.1897 12.7499L6.49968 12.7499C6.30077 12.7499 6.11001 12.6709 5.96935 12.5302C5.8287 12.3896 5.74968 12.1988 5.74968 11.9999C5.74968 11.801 5.8287 11.6102 5.96935 11.4696C6.11001 11.3289 6.30077 11.2499 6.49968 11.2499L16.1897 11.2499L13.4697 8.52991Z",
    fill: "#CF375D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.d8f1edab8c50b50157a91af1e2db1453.svg";
export { ForwardRef as ReactComponent };